import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { PanoramaVm } from "../../../data/k-projects/panorama.data";
import { DownArrow } from "../../../icons";
import useCommonDataStore from "../../../stores/common.store";
import useViewStore from "../../../stores/viewer.store";
import PanoramaPopup from "../../PanoramaPopup";
import usePanoramaPins from "../usePanoramaPins";

const backgroundStyle = {
  borderRadius: "5px",
  border: "solid 1px white",
  marginBottom: "8px",
};

const prefix = "hqrooftop";
export default function RooftopMenuBtn() {
  const [isOpen, setIsOpen] = React.useState(false);
  const { commonData, setCommonData } = useCommonDataStore();

  const toggleDropdown = () => {
    setCommonData({
      ...commonData,
      isActive: !isOpen ? "panorama" : "",
      slider: false,
      openIndex:"",
    });
    setIsOpen(!isOpen);
  };

  React.useEffect(() => {
    const { isActive } = commonData;
    if (isActive !== "panorama") setIsOpen(false);
  }, [commonData]);

  const {init, clear} = usePanoramaPins({
    prefix: prefix!,
    vm: PanoramaVm,
    show: isOpen,
  });

  const { setPhase } = useViewStore();
  React.useEffect(() => {
    if (isOpen) setPhase(PanoramaVm.phase);
  }, [setPhase, isOpen]);

  return (
    <Box sx={backgroundStyle}>
      <PanoramaPopup clear={clear} init={init} prefix={prefix} show={isOpen} vm={PanoramaVm} />
      <Button
        sx={{
          padding: "0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          color: isOpen ? "yellow" : "white",
        }}
        onClick={toggleDropdown}
      >
        <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
          <Typography
            sx={{
              size: "14px",
              lineHeight: "22px",
              letterSpacing: "-0.43px",
              fontWeight: "700",
            }}
          >
            HQ 옥상 풍경 시뮬레이션
          </Typography>
          <DownArrow
            sx={{ marginLeft: "auto", width: "30px", height: "30px" }}
          />
        </Box>
        <Typography sx={{ fontSize: "10px" }}>(2025.01)</Typography>
      </Button>
    </Box>
  );
}
